(() => {
  const root = document.querySelector('.tsc-edit-page');
  if (!root) return;

  const pageHandle = root.dataset.tscPage || '';
  const heroProducts = {
    'styling-guide': 'collared-wrap-top-wide-leg-pants-set',
    'summer-outfit-ideas': 'linen-tie-front-top-shorts-set',
    'how-to-style-tops': 'sleeveless-polo-collar-crop-top',
    'how-to-style-layers': 'mixed-print-open-front-kimono-layer',
    'everyday-minimal-outfits': 'cotton-wide-leg-pants',
    'vacation-weekend-looks': 'backless-a-line-maxi-dress'
  };

  const guideProducts = {
    'summer-outfit-ideas': 'linen-tie-front-top-shorts-set',
    'how-to-style-tops': 'sleeveless-polo-collar-crop-top',
    'how-to-style-layers': 'mixed-print-open-front-kimono-layer',
    'everyday-minimal-outfits': 'cotton-wide-leg-pants',
    'vacation-weekend-looks': 'backless-a-line-maxi-dress'
  };

  const fallbackImages = {
    'collared-wrap-top-wide-leg-pants-set': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/CC60537B.jpg?v=1785140998',
    'linen-tie-front-top-shorts-set': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/linen-tie-front-top-shorts-set-sets-women-minimalist-fashion-quiet-luxury-7682705.jpg?v=1785152109',
    'sleeveless-polo-collar-crop-top': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/sleeveless-polo-collar-crop-top-tops-women-minimalist-fashion-quiet-luxury-1988795.jpg?v=1785152052',
    'mixed-print-open-front-kimono-layer': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/mixed-print-open-front-kimono-layer-light-layers-women-minimalist-fashion-quiet-luxury-4266136.jpg?v=1785152049',
    'cotton-wide-leg-pants': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/cotton-wide-leg-pants-pants-women-minimalist-fashion-quiet-luxury-3420289.jpg?v=1785152063',
    'backless-a-line-maxi-dress': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/backless-a-line-maxi-dress-dresses-women-minimalist-fashion-quiet-luxury-7294008.jpg?v=1785152113',
    'high-neck-racerback-tank': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/high-neck-racerback-tank-tops-women-minimalist-fashion-quiet-luxury-2665039.jpg?v=1785152065',
    'ruched-bust-a-line-dress': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/ruched-bust-a-line-dress-dresses-women-minimalist-fashion-quiet-luxury-5837216.jpg?v=1785152169',
    'ribbed-one-shoulder-cross-strap-top': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/ribbed-one-shoulder-cross-strap-top-tops-women-minimalist-fashion-quiet-luxury-3525274.jpg?v=1785152113',
    'ruffle-trim-sleeveless-top': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/ruffle-trim-sleeveless-top-tops-women-minimalist-fashion-quiet-luxury-9110832.jpg?v=1785152054',
    'floral-open-front-kimono-layer': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/floral-open-front-kimono-layer-light-layers-women-minimalist-fashion-quiet-luxury-6784598.jpg?v=1785152109',
    'dash-print-tassel-kimono-layer': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/dash-print-tassel-kimono-layer-light-layers-women-minimalist-fashion-quiet-luxury-9108072.jpg?v=1785152054',
    'high-rise-front-seam-straight-leg-jeans': 'https://cdn.shopify.com/s/files/1/0712/6456/7470/files/high-rise-front-seam-straight-leg-jeans-jeans-women-minimalist-fashion-quiet-luxury-9600818.jpg?v=1785152113'
  };

  const requests = new Map();

  const handleFromPath = (href, segment) => {
    try {
      const pathname = new URL(href, window.location.origin).pathname;
      const match = pathname.match(new RegExp(`/${segment}/([^/?#]+)`));
      return match ? match[1] : '';
    } catch (_) {
      return '';
    }
  };

  const productHandleForImage = (image) => {
    const productLink = image.closest('a[href*="/products/"]');
    if (productLink) return handleFromPath(productLink.href, 'products');

    const guideLink = image.closest('a[href*="/pages/"]');
    if (guideLink) {
      const guideHandle = handleFromPath(guideLink.href, 'pages');
      if (guideProducts[guideHandle]) return guideProducts[guideHandle];
    }

    if (image.closest('.te-hero-media')) return heroProducts[pageHandle] || '';
    return '';
  };

  const normalizeImageUrl = (url) => {
    if (!url) return '';
    return url.startsWith('//') ? `${window.location.protocol}${url}` : url;
  };

  const currentFeaturedImage = (handle) => {
    if (!handle) return Promise.resolve('');
    if (!requests.has(handle)) {
      requests.set(
        handle,
        fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error(`Product image request failed: ${response.status}`);
            return response.json();
          })
          .then((product) => normalizeImageUrl(product.featured_image || (product.images && product.images[0]) || ''))
          .catch(() => fallbackImages[handle] || '')
      );
    }
    return requests.get(handle);
  };

  const updateImage = async (image) => {
    const handle = productHandleForImage(image);
    if (!handle) return;
    const url = (await currentFeaturedImage(handle)) || fallbackImages[handle];
    if (!url) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = url;
    image.dataset.tscProductHandle = handle;
  };

  const images = Array.from(root.querySelectorAll('.te-hero-media img, .te-card-media img, .te-product-media img'));
  images.forEach((image) => updateImage(image));
})();